import { render, staticRenderFns } from "./Seo.vue?vue&type=template&id=0f89eaaf&scoped=true&"
import script from "./Seo.vue?vue&type=script&lang=js&"
export * from "./Seo.vue?vue&type=script&lang=js&"
import style0 from "./Seo.vue?vue&type=style&index=0&id=0f89eaaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/jason/development/social-marketing-recovered/client/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f89eaaf",
  null
  
)

export default component.exports